import React from 'react';

// Translations
import translate from '../Translate.js';

// Helpers
import { checkValidity } from '../../helpers/helpers.js';

// Components
// import SignUp from './SignUp.js';
import SignIn from './SignIn.js';
import ResetPassword from './ResetPassword.js';
import {observer} from "mobx-react";

const Session = observer (class Session extends React.Component {
  constructor() {
    super();
    this.createProctor = this.createProctor.bind(this);
    this.handleSignup = this.handleSignup.bind(this);
  }

  componentWillMount() {
    this.state = {
      pageContent: <SignIn {...this.props} checkValidity={checkValidity} />,
      username: null,
      password: null
    }

    if(this.props.store.SessionStore.userData && sessionStorage.getItem('token')) {
      // Redirect to dashboard if the user is already logged in
      this.props.routing.history.push('/');
    } else {
      // Otherwise, clear out old session data
      this.props.store.SessionStore.removeLocalStorage();
    }

    if(this.props.content === 'Reset') {
      this.state = {
        pageContent: <ResetPassword {...this.props} checkValidity={checkValidity} />
      };
    }

    // if(this.props.content === 'SignUp') {
    //   this.setState({
    //     pageContent: <SignUp {...this.props} createProctor={this.createProctor} checkValidity={checkValidity} handleSignup={this.handleSignup} />
    //   });
    // }
    //
    // if(this.props.content === 'SignIn') {
    //   this.setState({
    //     pageContent: <SignIn {...this.props} checkValidity={checkValidity} />
    //   });
    // }
  }

  createProctor() {
    this.props.store.RegisterStore.createProctor(this.handleSignup);
  }

  handleSignup() {
    this.props.routing.history.push('/register');
  }

  render() {
    // const { translation } = this.props;

    const backgroundImg = 'url(../static/img/bg-sign-up.jpg)';

    return(
      <main className="page page--graphic page--pane-right" style={{backgroundImage: backgroundImg}}>
        <div className="page--graphic__content wrap">
          <img src="../static/img/logo-white.png" width="300" alt="SmarterProctoring" />
        </div>

        <div className="pane pane--right pane--fixed">
          {this.state.pageContent}
        </div>
      </main>
    )
  }
})

export default translate('Session')(Session);



// WEBPACK FOOTER //
// ./src/app/components/Account/Session.js